$(document).ready(function(){
    addPollPrevQuestionFunction();
    addPollNextQuestionFunction();
    addPollSubmitQuestionFunction();
    addPollSubmitFunction();
})
function addPollNextQuestionFunction() {
    $('.nextPollQuestion').click(function (e) {
        var parentTab = $(this).parents('.tab-pane');
        parentTab.find('.error-screen').hide();
        if (parentTab.find('.materialize-choice_widget_expanded').length) {
            if (parentTab.find('.materialize-choice_widget_expanded').find('input:checked').length != 1) {
                parentTab.find('.error-screen').show();
            } else {
                $(parentTab).removeClass('active');
                $(parentTab).next('.tab-pane').addClass('active');
            }
        } else {
            if (parentTab.find('.input-field').find('input').val() == "") {
                parentTab.find('.error-screen').show();
            } else {
                $(parentTab).removeClass('active');
                $(parentTab).next('.tab-pane').addClass('active');
            }
        }
    });
}

function addPollSubmitQuestionFunction() {
    $('.submitPollQuestionForm').click(function (e) {
        var parentTab = $(this).parents('.tab-pane');
        parentTab.find('.error-screen').hide();
        if (parentTab.find('.materialize-choice_widget_expanded').length) {
            if (parentTab.find('.materialize-choice_widget_expanded').find('input:checked').length != 1) {
                parentTab.find('.error-screen').show();
                e.preventDefault();
            }
        } else {
            if (parentTab.find('.input-field').find('input').val() == "") {
                parentTab.find('.error-screen').show();
                e.preventDefault();
            }
        }
    });
}

function addPollPrevQuestionFunction() {
    $('.prevPollQuestion').click(function(e){
        var parentTab = $(this).parents('.tab-pane');
        parentTab.removeClass('active');
        parentTab.prev('.tab-pane').addClass('active');
    });
}

var submittingPoll = false;
function addPollSubmitFunction() {
    $('[name*=poll]').submit(function (e) {
        e.preventDefault();
        if (submittingPoll === false) {
            submittingPoll = true;
            var id = $(e.target).data('newsid');
            var pollId = $(e.target).data('pollid');
            var pollForm = new FormData(this);
            $.ajax({
                type: "POST",
                url: Routing.generate('news_poll', {id: id, pollId: pollId}),
                data: pollForm,
                processData: false,
                contentType: false
            }).done(function (data) {
                if (data.success) {
                    $(e.target).html('');
                    $(e.target).html(data.successMessage);
                }
            }).fail(function (data) {
            });
        }
    });
}
